<template>
 <div :class="windowClass">
   <v-container>
    <v-row>
      <v-col cols="12">
                <v-card>
               <v-toolbar>
                 <v-icon left color="primary">mdi-account-multiple-check</v-icon> CLAIMS
                 <v-spacer/>

                 
                 <span style="width: 290px;">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            dense
                            outlined
                            hide-details
                        ></v-text-field>
                 </span>
                 <span style="width: 100px; margin-left: 5px;">
                  <v-autocomplete
                  v-model="event_id"
                  :items="events"
                  item-value="id"
                  item-text="name"
                  @change="getUsers()"
                  hide-details
                  outlined
                    dense
                  label="Select Event"
                  ></v-autocomplete>
                 </span>
                 <span style="width: 100px; margin-left: 5px;">
                  <v-autocomplete
                  v-model="precinct"
                  :items="precincts"
                  hide-details
                  outlined
                    dense
                  label="Select Precinct"
                  ></v-autocomplete>
                 </span>
               </v-toolbar>
               <v-card-text>
          
                <span class="text-success font-weight-bold text-h6">EVENT: {{event_id}}</span>
                <span class="text-success font-weight-bold ml-4 text-h6">CLAIMS: {{byPrecinct.length}}</span>
                <span class="text-success font-weight-bold ml-4 text-h6">PRECINCT: {{precinct}}</span>
                <v-data-table
                    class="va-table"
                    dense
                    :headers="headers"
                    :search="search"
                    :items="byPrecinct"
                    >
                    <template v-slot:body="{ items }">
                        <tbody>
                        <tr v-for="(item,index) in items" :key="index">
                            <td>{{ item.prec }}</td>
                            <td>{{ item.fullname }}</td>
                            <td>{{item.claimed_by}}</td>
                            <td>{{$moment(item.claimed_dt).format("YYYY-MM-DD HH:mm A")}}</td>
                            <!-- <td>{{ item.role }}</td>
                             <td :class="STATUS_COLOR(item.status)">{{ item.status }}</td>
                            <td><v-icon left small :color="statusIndicator(item.last_login)">mdi-checkbox-blank-circle</v-icon> {{ $moment(item.last_login).fromNow()}}</td> -->
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
               </v-card-text>
             </v-card>
          </v-col>
         
    </v-row>
    </v-container>
   
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        event_id: 1,
        trans_dailog: false,
        areaform: false,
        state: 'new',
        user: {},
        events: [],
        search:'',
        areas:[],
        area:{},
        voter:{},
        voters:[],
        precinct:'ALL',
        precincts:[
        "ALL",
"0086A",
"0046A",
"0008D",
"0155C",
"0154A",
"0210D",
"0026B",
"0119A",
"0091B",
"0096C",
"0163C",
"0143B",
"0144D",
"0170F",
"0204C",
"0074D",
"0090C",
"0109D",
"0069D",
"0177C",
"0177B",
"0035A",
"0129A",
"0073B",
"0181D",
"0099A",
"0011B",
"0112B",
"0190A",
"0177E",
"0077B",
"0179D",
"0179C",
"0107B",
"0111A",
"0157A",
"0058B",
"0104A",
"0206B",
"0050A",
"0180C",
"0078B",
"0173A",
"0023C",
"0206C",
"0130A",
"0006B",
"0138C",
"0186C",
"0056A",
"0044C",
"0017D",
"0185F",
"0094A",
"0066C",
"0079A",
"0187G",
"0091E",
"0037C",
"0017C",
"0131B",
"0072D",
"0160A",
"0183C",
"0140C",
"0027A",
"0191G",
"0041A",
"0188I",
"0164A",
"0201A",
"0174B",
"0127B",
"0135B",
"0150B",
"0199C",
"0159C",
"0003C",
"0046D",
"0064A",
"0143D",
"0180B",
"0126C",
"0082A",
"0198B",
"0174D",
"0185A",
"0167A",
"0136B",
"0133C",
"0200C",
"0031B",
"0210A",
"0138D",
"0008B",
"0021A",
"0013D",
"0145C",
"0128C",
"0069J",
"0100B",
"0164B",
"0072B",
"0189A",
"0091C",
"0097C",
"0045D",
"0014A",
"0003A",
"0007A",
"0170A",
"0140D",
"0137C",
"0016A",
"0165C",
"0095B",
"0032C",
"0059C",
"0171A",
"0053B",
"0075D",
"0191C",
"0088C",
"0067B",
"0147A",
"0124C",
"0084B",
"0194A",
"0048B",
"0121A",
"0088B",
"0063A",
"0184C",
"0031A",
"0045A",
"0116A",
"0018A",
"0157B",
"0093B",
"0090A",
"0101A",
"0044A",
"0022B",
"0126B",
"0189B",
"0118B",
"0087C",
"0167B",
"0196A",
"0145A",
"0028A",
"0009C",
"0149A",
"0118D",
"0210C",
"0153C",
"0086C",
"0042A",
"0041B",
"0069H",
"0018C",
"0197C",
"0187D",
"0156A",
"0007C",
"0118A",
"0069B",
"0148C",
"0189E",
"0135C",
"0061A",
"0022C",
"0079B",
"0163A",
"0029B",
"0025B",
"0209B",
"0181C",
"0188D",
"0001A",
"0166C",
"0058C",
"0052C",
"0185H",
"0084A",
"0192A",
"0103B",
"0107A",
"0004A",
"0111B",
"0024B",
"0055D",
"0139D",
"0041C",
"0156B",
"0001C",
"0168B",
"0177D",
"0161C",
"0082C",
"0194B",
"0205A",
"0080A",
"0010D",
"0160C",
"0014D",
"0037A",
"0142B",
"0114C",
"0098A",
"0002B",
"0077A",
"0169A",
"0139C",
"0119B",
"0161B",
"0086D",
"0019C",
"0186A",
"0137B",
"0064C",
"0200B",
"0132D",
"0057C",
"0010B",
"0099B",
"0080C",
"0069E",
"0049B",
"0072C",
"0129C",
"0095C",
"0040A",
"0005A",
"0173C",
"0141C",
"0015C",
"0176B",
"0013A",
"0135A",
"0171B",
"0082B",
"0064B",
"0047C",
"0040C",
"0062A",
"0127A",
"0106A",
"0148B",
"0033D",
"0117A",
"0032B",
"0089D",
"0056C",
"0055A",
"0071A",
"0007D",
"0061B",
"0185G",
"0036A",
"0085B",
"0089B",
"0187E",
"0069G",
"0020C",
"0144C",
"0087B",
"0090E",
"0006A",
"0132C",
"0179A",
"0112A",
"0085C",
"0110B",
"0038A",
"0208A",
"0021C",
"0134C",
"0097A",
"0030C",
"0191A",
"0170D",
"0172A",
"0051A",
"0028B",
"0024C",
"0025C",
"0170C",
"0018D",
"0100D",
"0026A",
"0034B",
"0073D",
"0150C",
"0136A",
"0159A",
"0143C",
"0044D",
"0191E",
"0069F",
"0003D",
"0178B",
"0011D",
"0016B",
"0188A",
"0058D",
"0059A",
"0188G",
"0118C",
"0051B",
"0190C",
"0121C",
"0027C",
"0073A",
"0174E",
"0171E",
"0088A",
"0002C",
"0002A",
"0047B",
"0134B",
"0176D",
"0171D",
"0150A",
"0043C",
"0196C",
"0198C",
"0092C",
"0103A",
"0023B",
"0177A",
"0210B",
"0138E",
"0172B",
"0144A",
"0048C",
"0151C",
"0091D",
"0003B",
"0139B",
"0152A",
"0109A",
"0186G",
"0083A",
"0123B",
"0067A",
"0078C",
"0175B",
"0165B",
"0052B",
"0182A",
"0145B",
"0031C",
"0154B",
"0125A",
"0127C",
"0183A",
"0075C",
"0044B",
"0207A",
"0024A",
"0173B",
"0152B",
"0131A",
"0186F",
"0166A",
"0175C",
"0101B",
"0049D",
"0145E",
"0108A",
"0126A",
"0197B",
"0208B",
"0115B",
"0197D",
"0185D",
"0202A",
"0190E",
"0133D",
"0160B",
"0020B",
"0191F",
"0144B",
"0114B",
"0166D",
"0133A",
"0187H",
"0057A",
"0009A",
"0070C",
"0009B",
"0085A",
"0021B",
"0188H",
"0091A",
"0110A",
"0046B",
"0176A",
"0170E",
"0010C",
"0054A",
"0192C",
"0108B",
"0176F",
"0105B",
"0128B",
"0193C",
"0190D",
"0127D",
"0143A",
"0194C",
"0054C",
"0205B",
"0203B",
"0032A",
"0030A",
"0108D",
"0071D",
"0052A",
"0169B",
"0189F",
"0081B",
"0036B",
"0130B",
"0144E",
"0180A",
"0097B",
"0072A",
"0089A",
"0108C",
"0066A",
"0050B",
"0014C",
"0132B",
"0142A",
"0015B",
"0057D",
"0188F",
"0022A",
"0178C",
"0071B",
"0207B",
"0049A",
"0076B",
"0202B",
"0020A",
"0193A",
"0191D",
"0159B",
"0109B",
"0063C",
"0071C",
"0069A",
"0145D",
"0123C",
"0030B",
"0080D",
"0034C",
"0149B",
"0158A",
"0028C",
"0011A",
"0201B",
"0198D",
"0140B",
"0141D",
"0199B",
"0175A",
"0152C",
"0090D",
"0113A",
"0137A",
"0120A",
"0186B",
"0012B",
"0168C",
"0025A",
"0189D",
"0179B",
"0074A",
"0100A",
"0203A",
"0065B",
"0170G",
"0181B",
"0076D",
"0087A",
"0005D",
"0012A",
"0157C",
"0153A",
"0078A",
"0096A",
"0198A",
"0153D",
"0120B",
"0007B",
"0056B",
"0014B",
"0037B",
"0065A",
"0005B",
"0019A",
"0125C",
"0173D",
"0180D",
"0053C",
"0182B",
"0051C",
"0001E",
"0070B",
"0102A",
"0128A",
"0012D",
"0096B",
"0142D",
"0069C",
"0019D",
"0196B",
"0083B",
"0068A",
"0017B",
"0090B",
"0151A",
"0192B",
"0004E",
"0015D",
"0148A",
"0011C",
"0204B",
"0060C",
"0136D",
"0171C",
"0185C",
"0074B",
"0055B",
"0190F",
"0151B",
"0174C",
"0197A",
"0054B",
"0123A",
"0017A",
"0162A",
"0074C",
"0199A",
"0042B",
"0122B",
"0139E",
"0161A",
"0049C",
"0165D",
"0132A",
"0059D",
"0190B",
"0195C",
"0075B",
"0138A",
"0095A",
"0121B",
"0008C",
"0087E",
"0006D",
"0008E",
"0038B",
"0075A",
"0163D",
"0005C",
"0170B",
"0176G",
"0006E",
"0086B",
"0063B",
"0105A",
"0027B",
"0076C",
"0142C",
"0135D",
"0048A",
"0167C",
"0081A",
"0174A",
"0094B",
"0136E",
"0120C",
"0178D",
"0206A",
"0146B",
"0057B",
"0138B",
"0100C",
"0114A",
"0187C",
"0115A",
"0153B",
"0040B",
"0087D",
"0060A",
"0089E",
"0019B",
"0189C",
"0204A",
"0045B",
"0006C",
"0188E",
"0155A",
"0012C",
"0107D",
"0008A",
"0122C",
"0199D",
"0119D",
"0209A",
"0178A",
"0073C",
"0185E",
"0106B",
"0187B",
"0139A",
"0124A",
"0129B",
"0001B",
"0069I",
"0079C",
"0169C",
"0171G",
"0195A",
"0045C",
"0188B",
"0001D",
"0136C",
"0124B",
"0023A",
"0081C",
"0171F",
"0043B",
"0013C",
"0021D",
"0209C",
"0184B",
"0134D",
"0042C",
"0107C",
"0110C",
"0076A",
"0147B",
"0093A",
"0141A",
"0184A",
"0058A",
"0010A",
"0168A",
"0188C",
"0145F",
"0080B",
"0119C",
"0165A",
"0059B",
"0187A",
"0183B",
"0141E",
"0053A",
"0125B",
"0043A",
"0176E",
"0070A",
"0185B",
"0142E",
"0066B",
"0187F",
"0200D",
"0141B",
"0060B",
"0015A",
"0046C",
"0055C",
"0033C",
"0143E",
"0181A",
"0200A",
"0013B",
"0004B",
"0134A",
"0033A",
"0029A",
"0092A",
"0062B",
"0035C",
"0109C",
"0101C",
"0195B",
"0098B",
"0191B",
"0004C",
"0186D",
"0166B",
"0186E",
"0163B",
"0176C",
"0193B",
"0004D",
"0122A",
"0092B",
"0035B",
"0018B",
"0092D",
"0034A",
"0089C",
"0140A",
"0039A",
"0201C",
"0033B",
"0016C",
"0133B",
"0146A",
"0016D",
"0047A",
"0155B"
],
        headers: [
          { text: 'Prec', value:"prec"},
            { text: 'Name', value:"fullname"},
             { text: 'Claimed By', value:"claimed_by"},
             { text: 'ClaimedDT', value:"claimed_dt"}
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getUsers()
          this.getEvents()
         
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      byPrecinct() {
        if(this.precinct == "ALL") {
          return  this.voters
        }
        var voters = this.voters.reduce((res,item)=>{
          if(item.prec == this.precinct) {
            res.push(item)
          }
          return res
        },[])

        return voters
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      transEvent(){
        this.trans_dailog = false
      },
      statusIndicator(_time) {
          //var current = this.$moment(_time)
          var a = this.$moment()
            var b = this.$moment(_time)
           var diff = a.diff(b, 'hour')
           if(diff <=  3) {
              return 'success'
           } else if(diff > 3 && diff < 5) {
               return '#A5D6A7'
           } else {
             return '#989898'
           }
      },
      CountBarangay(area){
          var _count = area.reduce((res,item)=>{
                res += item.barangays.length
                return res
          },0) 
          return _count
      },
      afEvent() {
        this.areaform = false
        this.getAreas()
      },
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
            console.log(data)
              this.voter = data.voter
              this.Save()
          }
      },

    
      getEvents: function() { 
        this.$http.get("event/list").then(response => {
            response.data.items != null?this.events = response.data.items:this.events =[]
        }).catch(e => {
        console.log(e.data)
        })
     },
      getUsers: function() { 
        this.voters = []
        this.$http.post("claims/list", {event_id: this.event_id}).then(response => {
          console.log(response.data)
            response.data.list != null?this.voters = response.data.list:this.voters =[]
        }).catch(e => {
        console.log(e.data)
        })
     },
    
      Save: function() {
        let method = 'voter/register'
        this.state != 'new'?method='voter/update':method = 'voter/register'
        console.log(method, this.voter)
        this.$http.post(method, this.voter).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getUsers()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>